import storage from "@/_util/storage-methods"

export default [

    {
        name : "workQueue",
        get : [],
        set : null,
    },
    {
        name : "errors",
        get : [],
        set : null,
    },
    {
        name: "mainNavEnabled",
        get: true,//storage.getLocalStorageBoolean("main-nav-open", true),
        set: null,//storage.setLocalStorage("main-nav-open"),
    },
    {
        name: "isShowLeftNav", //handles custom navigation in mobile view
        get: storage.getLocalStorageBoolean("show-left-nav", false),
        set: storage.setLocalStorage("show-left-nav"),
    },    
    {
        name: "notification",
        get: () => [],
        set: null,
    },
];
